import { hobbiiSessionStorage } from './web-storage';

/**
 * Feature flags utility module
 * Provides persistent storage and management of feature flags using localStorage
 */

const FEATURE_FLAG_KEY = 'hobbii_feature_flags';

const getStoredFeatureFlags = (): Record<string, boolean> => {
  const storedFlags = hobbiiSessionStorage.getItem(FEATURE_FLAG_KEY);
  if (!storedFlags) return {};

  try {
    return JSON.parse(storedFlags);
  } catch {
    console.warn('Failed to parse stored feature flags');
    return {};
  }
};

export const setFeatureFlag = (flagName: string, value: boolean): void => {
  const currentFlags = getStoredFeatureFlags();
  const updatedFlags = { ...currentFlags, [flagName]: value };
  hobbiiSessionStorage.setItem(FEATURE_FLAG_KEY, JSON.stringify(updatedFlags));
};

export const getFeatureFlag = (flagName: string): boolean | undefined => {
  const storedFlags = getStoredFeatureFlags();
  return storedFlags[flagName];
};

export const getAllFeatureFlags = (): Record<string, boolean> => {
  return getStoredFeatureFlags();
};

export const initializeFeatureFlags = (): void => {
  // Check if show_cart_rewards is already stored
  const existingFlag = getFeatureFlag('show_cart_rewards');

  if (existingFlag !== undefined) {
    return; // Flag already exists, no need to fetch
  }

  // Only fetch from PostHog if we don't have a stored value
  const flagValue =
    window.posthog?.getFeatureFlag('show_cart_rewards') === 'test';
  setFeatureFlag('show_cart_rewards', flagValue);
};

/**
 * Conditionally initialize feature flags based on threshold validation
 */
export const conditionallyInitializeFeatureFlags = (): void => {
  const container = document.querySelector<HTMLElement>(
    '.js-threshold-visualizer'
  );

  if (!container) return;

  const shippingThresholdValid =
    container.dataset.shippingThresholdValid === 'true';
  const giftThresholdValid = container.dataset.giftThresholdValid === 'true';

  // Only initialize feature flags when both thresholds are valid
  if (shippingThresholdValid && giftThresholdValid) {
    initializeFeatureFlags();
  }
};
